<template>
    <v-row>
      <v-col cols="12" sm="7">
        Pedido em <b>{{ compra.dataCompra | date }}</b> | Pedido  <b>nº {{ compra.id }}</b>
        <px-situacao-compra-marketplace-text is-fornecedor
                                             class="ml-3"
                                             :situacao="compra.situacao"/>
      </v-col>
      <v-col cols="12" sm="5" class="text-right">
        <px-compra-gerar-pagamento-dialog v-if="showGerarPagamento"
                                          btn-class="mt-3 rounded-tag-small normal-btn-text"
                                          :compra="compra"
                                          @movimentar="onMovimentar"/>
        <px-compra-cancelar-dialog btn-class="mt-3 rounded-tag-small normal-btn-text"
                                   v-if="!hideCancelado"
                                   :compra="compra"
                                   @movimentar="onMovimentar"/>
        <px-compra-aprovar-dialog btn-class="mt-3 ml-2 rounded-tag-small normal-btn-text"
                                  v-if="!hideAprovar"
                                  :compra="compra"
                                  @movimentar="onMovimentar"/>
      </v-col>
    </v-row>
</template>

<script>
import { SituacaoCompraMarketplace, SituacaoPagamento } from 'px-business-components';
import CompraCancelarDialog from './CompraCancelarDialog.vue';
import CompraAprovarDialog from './CompraAprovarDialog.vue';
import CompraGerarPagamentoDialog from './CompraGerarPagamentoDialog.vue';

export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hideCancelado() {
      return this.compra.situacao !== SituacaoCompraMarketplace.keys.ENVIADA.key;
    },
    hideAprovar() {
      return this.compra.situacao !== SituacaoCompraMarketplace.keys.ENVIADA.key;
    },
    isAprovada() {
      return this.compra.situacao === SituacaoCompraMarketplace.keys.APROVADA.key;
    },
    showGerarPagamento() {
      return this.isAprovada && this.compra.ajustaValorFinal
        && this.compra.situacaoPagamento === SituacaoPagamento.keys.AGUARDANDO_VALOR.key;
    },
  },
  methods: {
    onMovimentar() {
      this.$emit('change');
    },
  },
  components: {
    pxCompraCancelarDialog: CompraCancelarDialog,
    pxCompraAprovarDialog: CompraAprovarDialog,
    pxCompraGerarPagamentoDialog: CompraGerarPagamentoDialog,
  },
};
</script>
